import { render, staticRenderFns } from "./OrganizationEdit.vue?vue&type=template&id=98adfcd2&"
import script from "./OrganizationEdit.vue?vue&type=script&lang=js&"
export * from "./OrganizationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98adfcd2')) {
      api.createRecord('98adfcd2', component.options)
    } else {
      api.reload('98adfcd2', component.options)
    }
    module.hot.accept("./OrganizationEdit.vue?vue&type=template&id=98adfcd2&", function () {
      api.rerender('98adfcd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/organizations/OrganizationEdit.vue"
export default component.exports